import { render, staticRenderFns } from "./Modal-Add-Teacher.vue?vue&type=template&id=2af59c3c&scoped=true"
import script from "./Modal-Add-Teacher.vue?vue&type=script&lang=js"
export * from "./Modal-Add-Teacher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af59c3c",
  null
  
)

export default component.exports